export var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["baseline"] = "align-baseline";
    VerticalAlignment["top"] = "align-top";
    VerticalAlignment["middle"] = "align-middle";
    VerticalAlignment["bottom"] = "align-bottom";
    VerticalAlignment["textTop"] = "align-text-top";
    VerticalAlignment["textBottom"] = "align-text-bottom";
})(VerticalAlignment || (VerticalAlignment = {}));
